/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description integration config
 */

import { DEFAULT_TENANT_NAME } from '@admin-vite/utils/constants';

const isLocalhost = ENVIRONMENT === 'localhost';
const isIntegration = true;
const hostname = isLocalhost ? `${DEFAULT_TENANT_NAME}.okjeeves.tech` : globalThis.location.hostname;
const apexDomain = hostname.split('.').slice(-2).join('.');
const tenant = hostname.split('.')[0];
const serverHost = `${tenant}.api.${apexDomain}`;

if (!tenant) {
	throw new Error('Tenant is not set');
}

const config: JeevesAppConfig = {
	environment: ENVIRONMENT,
	isLocalhost,
	isIntegration,
	isProduction: false,
	basePath: isLocalhost ? '/' : globalThis.basePath,
	hostname,
	origin: `https://${hostname}`,
	tld: 'tech',
	tenant,
	client: {
		url: `https://${serverHost}`,
	},
	chatAgent: {
		url: 'https://jeeves-agent.314ecorp.tech',
	},
	keycloak: {
		url: globalThis.AUTH_URL ?? `https://${hostname}/auth`,
		realm: tenant,
		clientId: sessionStorage.getItem('AUTH_CLIENT') ?? 'jeeves',
	},
	novu: {
		backendUrl: `https://${serverHost}/alerting`,
		socketUrl: `wss://${serverHost}`,
	},
	posthog: {
		apiKey: 'phc_jQen3LUrvQKBPCv0lZhbEQdrdbuYwfExU6pr6f3jg35',
		options: {
			api_host: `https://${tenant}.okjeeves.tech/_ph`,
			opt_out_capturing_by_default: isLocalhost,
			capture_pageview: false,
			capture_pageleave: false,
		},
	},
	faro: {
		url: `https://${serverHost}/logcollect`,
		apiKey: 'tX4Pe@NE',
	},
	adobeClientId: 'a2efdb2376bb45a58541d017cc9e42d3',
};

export default config;
